import React from 'react';
import './LegalPages.css';

const CookiesPolicy = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Cookie Policy</h1>
        <p className="last-updated">Last updated: January 2026</p>

        <section>
          <h2>What Are Cookies</h2>
          <p>
            Cookies are small text files that are placed on your computer or mobile device when you visit our website. 
            They are widely used to make websites work more efficiently and provide information to website owners.
          </p>
        </section>

        <section>
          <h2>How We Use Cookies</h2>
          <p>WasteMapr uses cookies for the following purposes:</p>
          <ul>
            <li><strong>Essential Cookies:</strong> Required for the website to function properly, including user authentication and session management.</li>
            <li><strong>Preference Cookies:</strong> Remember your preferences, such as language settings and display options.</li>
            <li><strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website to improve user experience.</li>
          </ul>
        </section>

        <section>
          <h2>Types of Cookies We Use</h2>
          <table className="cookie-table">
            <thead>
              <tr>
                <th>Cookie Type</th>
                <th>Purpose</th>
                <th>Duration</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Session Cookies</td>
                <td>Maintain your login state and preferences during your visit</td>
                <td>Session</td>
              </tr>
              <tr>
                <td>Authentication</td>
                <td>Keep you logged in securely across pages</td>
                <td>7 days</td>
              </tr>
              <tr>
                <td>Preferences</td>
                <td>Remember your cookie consent choice</td>
                <td>1 year</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section>
          <h2>Your Cookie Choices</h2>
          <p>
            You can choose to accept or reject cookies when you first visit our website. 
            You can also manage cookies through your browser settings at any time:
          </p>
          <ul>
            <li>Most browsers allow you to view, delete, and block cookies</li>
            <li>Blocking essential cookies may affect website functionality</li>
            <li>You can clear your cookie consent choice by clearing your browser data</li>
          </ul>
        </section>

        <section>
          <h2>Managing Your Cookie Preferences</h2>
          <p>
            To change your cookie preferences, you can clear your browser's local storage and refresh the page. 
            The cookie consent banner will appear again, allowing you to make a new choice.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have questions about our cookie policy, please contact us at{' '}
            <a href="mailto:privacy@wastemapr.com">privacy@wastemapr.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default CookiesPolicy;
